const _ = require("lodash");
const CanvasUtil = require("./CanvasUtil");
const SoundsLogging = require("./SoundsLogging");
const bugOptions = require("./CopyTable").getBugReportOptions("all");

const generateBugReportData = function(inputData = {}, props = {}) {
	const {reason, description} = inputData;
	const type = bugOptions[reason];
	const reporter = _.get(props, "user.userID", 0);
	const baBlocks = type === "problem";
	const baDev = type === "site";
	const baNeverland = type === "neverland";
	const blockID = _.get(props, "block.blockID", 0);
	const labBlockID = _.get(props, "labBlock.blockID", 0);
	const soundsLog = SoundsLogging.getLog();

	let reportTitle = null;
	switch (type) {
		case "site":
			reportTitle = "Student Site Bug Report";
			break;
		case "problem":
			reportTitle = "Student Problem Bug Report";
			break;
		default:
			reportTitle = "Student Bug Report";
	}

	let problemInfo = "";
	const page = _.get(props, "page") || {};
	const pageType = _.get(page, "name", "").split(".")[0];
	if (pageType === "trainer") {
		const problemIndex = _.get(
			props,
			"result.currentProblemIndex",
			"not found"
		);
		if (problemIndex >= 0) {
			const problem = _.get(props, ["result", "problems", problemIndex], {});
			const problemModel = _.get(problem, "model", {});
			const baEditorID = _.get(problemModel, "baeditorID", "unknown");
			problemInfo += "\n\n**baeditorID:** " + baEditorID;
			if (baNeverland && baEditorID !== "unknown") {
				reportTitle += " baeditorID " + baEditorID;
			}
			problemInfo += "\n\n--- \n\n";
			problemInfo +=
				"**Their Responses:** " +
				_.get(problem, "trials", [])
					.map(v => JSON.stringify(v))
					.join(", ");
			let answers = _.get(problemModel, "answers", false);
			answers = answers || _.get(problemModel, "singleInputAnswers", false);
			if (answers) {
				problemInfo +=
					"\n**Our Answers:** " +
					answers.map(v => JSON.stringify(v)).join(", ");
			}
		}

		const {chapterIndex, blockIndex} = page;
		problemInfo +=
			"\n**Grade Number:** " + _.get(page, "gradeNumber", "not found");
		const chapterNumber = _.isNumber(chapterIndex)
			? chapterIndex + 1
			: "not found";
		problemInfo += "\n**Chapter Number:** " + chapterNumber;
		if (_.get(page, "blockType", "character") === "character") {
			const blockNumber = _.isNumber(blockIndex) ? blockIndex + 1 : "not found";
			problemInfo += "\n**Block Number:** " + blockNumber;
		} else {
			problemInfo +=
				"\n**Block Type:** " + _.capitalize(_.get(page, "blockType", ""));
		}

		const user = _.get(props, "user", {});
		problemInfo +=
			"\n**Set Number:** " + _.get(props, "result.setNumber", "not found");
		if (_.get(user, "currentActivity")) {
			problemInfo +=
				"\n**Activity subobjectID:** " +
				_.get(user, "currentActivity.subobjectID", "not found");
			problemInfo +=
				"\n**Activity objectID:** " +
				_.get(user, "currentActivity.objectID", "not found");
		}
	} else if (pageType === "lab") {
		const labProblemIndex = _.get(
			props,
			"result.currentProblemIndex",
			"not found"
		);
		if (labProblemIndex >= 0) {
			const labBAEditorID = _.get(
				props,
				["result", "problems", labProblemIndex, "model", "baeditorID"],
				"unknown"
			);
			problemInfo += "\n**baeditorID:** " + labBAEditorID;
			if (baNeverland && labBAEditorID !== "unknown") {
				reportTitle += " baeditorID " + labBAEditorID;
			}
		}
	} else {
		problemInfo +=
			"\n**Section:** " +
			_.get(props, "user.currentActivity.section", "not found");
	}

	const href = window.location.href;
	const {width, height, windowWidth, windowHeight} = props.containerDims;
	const studentDescription = `
## Student's Description:
${description}

---

**Browser:** ${window.navigator.userAgent}

---

**URL:** [${href}](${href})
`;
	const sizes = `
**Trainer Size:** ${Math.ceil(width)}x${Math.ceil(height)}
**Window Size:** ${Math.ceil(windowWidth)}x${Math.ceil(windowHeight)}
**DPI:** ${CanvasUtil.getDPR()}
`;
	const reportBody = `
${studentDescription}

${problemInfo}

${sizes}
`;

	return {
		reporter,
		reportTitle,
		reportBody,
		baBlocks,
		baDev,
		baNeverland,
		blockID,
		labBlockID,
		type,
		soundsLog,
		userReason: reason,
		userDescription: description,
	};
};

module.exports = {
	generateBugReportData,
};
